var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('div',[_c('asset-header-card',{attrs:{"asset":_vm.asset,"fftlog":false,"three-dimensional":true,"telemetry":false}}),_c('asset-log-three',{attrs:{"asset-i-d":_vm.asset.assetID}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }